import React, { Component } from "react";

class About extends Component {
  render() {
    return (
      <div className="container about">
        <h3>Hello there!</h3>
        <p className="lead">
          My name's Keith and I like to build things. I'm a UX/Interaction
          designer by training, now a software developer by trade. I have a
          passion for building all kinds of media - from game design to writing
          to film to interaction design.
          <br />
          <br />
          Graduating with a degree in New Media, specifically in UX and
          interaction design, I set out to design beautiful digital experiences,
          but found myself wanting to know more about how to build them as well.
          Since then, I’ve created full-featured web platforms and mobile apps,
          QA strategies and testing frameworks, marketing and analytics web
          pages, and led engineering efforts for UI components and design
          systems.
          <br />
          <br />
          I’m fuelled by a love for learning and a constant desire to become
          better at what I do, and my love for technology has led me to learning
          the craft of programming and developing software.
        </p>
      </div>
    );
  }
}

export default About;
